<template>
    <div>
        <main>
            <div class="wide-wrapper">
                <h2>New! Pilates Cadillac Flashcards by Lesley Logan</h2>

                <div class="upper-content-wrapper">
                    <photo-grid :feature="featureImgHtml">
                        <photo
                            @setFeature="setFeatureImg"
                            src="contrology_cadillacflashcards_teaser01@1x.jpg"
                            src2="contrology_cadillacflashcards_teaser01@2x.jpg"
                            alt="Photo of Flashcards"
                        />
                        <photo
                            @setFeature="setFeatureImg"
                            src="contrology_cadillacflashcards_teaser02@1x.jpg"
                            src2="contrology_cadillacflashcards_teaser02@2x.jpg"
                            alt="Photo of Flashcards"
                        />
                        <photo
                            @setFeature="setFeatureImg"
                            src="contrology_cadillacflashcards_teaser03@1x.jpg"
                            src2="contrology_cadillacflashcards_teaser03@2x.jpg"
                            alt="Photo of Flashcards"
                        />
                    </photo-grid>

                    <cta-prod-button
                        class="cta-button wide"
                        link="cadillac"
                        src="contrology-cad1@1x.jpg"
                        src2="contrology-cad1@2x.jpg"
                        alt="Product photo of Contrology Cadillac"
                        productName="Contrology Cadillac"
                    />

                    <div class="content-wrapper">
                        <section class="intro">
                            <h2>New! Pilates Cadillac Flashcards by Lesley Logan</h2>
                            <p>
                                110+ full color flashcards to help you study the classical Pilates Cadillac/Tower exercises. Learn the exercise set up, action and complimentary exercises as well as some preps to help you understand the movements in your body. Additionally, find related exercises for the <a href="/folding-mat">Mat</a> and <a href="/reformer">Reformer</a> that pair with the <a href="/cadillac">Cadillac</a> exercise, and pointers to dive deeper into every movement. Scan the barcode on the front of each card to watch a video of the exercise.
                            </p>
                            <p>
                                For sale to customers in US & Canada only.
                            </p>
                        </section>

                        <product-selector
                            :products="products"
                            :product="product"
                            :option1="option1"
                            :option2="option2"
                            :isdistcountry="isdistcountry"
                        />

                        <section class="links">
                            <icon-link
                                url="support#returns"
                                img="icon-guarantee.svg"
                                alt="Guarantee icon"
                                title="Learn more"
                                >30-Day Money Back Guarantee</icon-link
                            >
                        </section>

                        <cta-prod-button
                            class="cta-button"
                            link="cadillac"
                            src="contrology-cad1@1x.jpg"
                            src2="contrology-cad1@2x.jpg"
                            alt="Product photo of Contrology Cadillac"
                            productName="Contrology Cadillac"
                        />
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import CtaProdButton from "@/components/CtaProdButton.vue";

export default {
    name: "cadillacflashcards",

    metaInfo: {
        title: "Cadillac Flashcards - Lesley Logan Flashcards",
        titleTemplate: "%s",
        meta: [
            {
                name: "description",
                content: "110+ full color flashcards to help you study the classical Pilates Cadillac/Tower exercises.",
            },
        ],
    },

    components: {
        PhotoGrid,
        Photo,
        ProductSelector,
        IconLink,
        CtaProdButton,
    },

    props: {
        isdistcountry: Boolean,
    },

    data() {
        return {
            featureImgHtml: "", // PhotoGrid
            product: {
                label: "Select Product",
                value: "",
                key: "name",
            },
            option1: {},
            option2: {},
            products: [
                // Product options
                {
                    prodid: 42458275709121,
                    partnumber: 18273,
                    price: 99.99,
                    name: "Cadillac Flashcards",
                    available: true,
                },
            ],
        };
    },

    methods: {
        // Set PhotoGrid featured image
        setFeatureImg(html) {
            this.featureImgHtml = html;
        },
    },
};
</script>

<style lang="scss" scoped>
h2 {
    text-align: center;
    margin: 0;
    padding: 0;
}

h2 + h3 {
    display: none;
}

.intro h2 {
    display: none;
}

.intro h3 {
    display: block;
}

.intro p {
    font-family: var(--roboto);
    font-size: 0.9375rem;
    line-height: 1.467;
    color: #333;
}

.wide {
    display: none;
}

.links {
    margin-top: 30px;
}

.content-link {
    text-decoration: underline;
    cursor: pointer;
    color: #000;
}

@media only screen and (min-width: 768px) {
    h2 + h3 {
        display: block;
        margin: 0;
    }

    .intro h3 {
        display: none;
    }

    .upper-content-wrapper {
        padding: 0 80px;
    }

    .content-wrapper {
        max-width: 530px;
        margin: 0 auto;
    }

    .links {
        column-count: 3;
        position: relative;
        margin-top: 15px;
    }

    .links > * {
        -webkit-column-break-inside: avoid;
        page-break-inside: avoid;
        break-inside: avoid;
    }

    .icon-link {
        margin-top: 0;
    }

    ::v-deep .modal-card-wrapper {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
    }
}

@media only screen and (min-width: 1024px) {
    .upper-content-wrapper {
        padding: 0 45px;
        display: flex;
        align-items: flex-start;
        max-width: 900px;
        margin: 0 auto 30px;
    }

    .content-wrapper {
        width: 340px;
        display: flex;
        flex-flow: column nowrap;
    }

    .intro {
        order: 1;
        margin-top: 15px;
    }

    .cta-button {
        order: 3;
        margin: 20px 0 10px;
    }

    .links {
        column-count: 1;
        order: 4;
    }

    .icon-link {
        margin: 0;
    }

    .more {
        order: 5;
        margin-top: 20px;
    }
}

@media only screen and (min-width: 1208px) {
    .wide-wrapper {
        background-color: rgba(255, 255, 255, 0.75);
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto auto auto auto;
        position: relative;
        z-index: 0;
        max-width: 1050px;
        margin: 0 auto;
    }

    .upper-content-wrapper {
        display: contents;
    }

    .photo-grid-wrapper {
        grid-column: 1 / span 1;
        grid-row: 1 / span 2;
    }

    .content-wrapper {
        width: auto;
        grid-column: 2 / span 1;
        grid-row: 1 / span 1;
        margin: 50px 30px 20px 0;
        max-width: 600px;
    }

    .cta-button {
        display: none;
    }

    .cta-button.wide {
        display: flex;
        grid-column: 1 / span 1;
        grid-row: 3 / span 1;
        justify-self: center;
        margin: 0 80px 30px auto;
    }

    .intro h2,
    .intro h3 {
        display: block;
        text-align: left;
    }

    .wide-wrapper > h2,
    .wide-wrapper > h3 {
        display: none;
    }

    .links {
        column-count: 2;
        max-width: 400px;
    }

    .icon-link {
        margin: 1px;
    }
}
</style>
